module.exports = __webpack_public_path__ + "img/publish-due.35068c51.svg";